(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_9335c80"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var sliders = document.querySelectorAll('[class^="ai-related-blogs-slider-"]');
    if (!sliders.length) return;

    sliders.forEach(function(slider) {
      var classes = Array.prototype.slice.call(slider.classList);
      var sliderClass = classes.find(function(c) {
        return c.indexOf('ai-related-blogs-slider-') === 0;
      });

      if (!sliderClass) return;

      var sliderId = sliderClass.replace('ai-related-blogs-slider-', '');

      var track = slider.querySelector('.ai-related-blogs-track-' + sliderId);
      if (!track) return;

      var slides = track.querySelectorAll('.ai-related-blogs-card-' + sliderId);
      if (!slides.length) return;

      var prevButton = slider.querySelector('.ai-related-blogs-prev-' + sliderId);
      var nextButton = slider.querySelector('.ai-related-blogs-next-' + sliderId);

      var currentIndex = 0;
      var startX = 0;
      var currentX = 0;
      var isDragging = false;

      function getSlidesPerView() {
        return window.matchMedia('(min-width: 750px)').matches ? 4 : 1;
      }

      function getSlideWidth() {
        if (!slides.length) return 0;
        return slides[0].getBoundingClientRect().width;
      }

      function getGap() {
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.gap || style.columnGap || '0');
        if (isNaN(gap)) return 0;
        return gap;
      }

      function getStepSize() {
        return getSlideWidth() + getGap();
      }

      function updateSlider() {
        var perView = getSlidesPerView();
        var maxIndex = Math.max(0, slides.length - perView);

        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }

        var step = getStepSize();
        var offset = -step * currentIndex;
        track.style.transform = 'translateX(' + offset + 'px)';

        if (prevButton) {
          prevButton.disabled = currentIndex === 0;
        }
        if (nextButton) {
          nextButton.disabled = currentIndex >= maxIndex;
        }
      }

      if (prevButton) {
        prevButton.addEventListener('click', function() {
          if (currentIndex <= 0) return;
          currentIndex -= 1;
          updateSlider();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function() {
          var perView = getSlidesPerView();
          var maxIndex = Math.max(0, slides.length - perView);
          if (currentIndex >= maxIndex) return;
          currentIndex += 1;
          updateSlider();
        });
      }

      // swipe (touch) support
      track.addEventListener('touchstart', function(e) {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
        currentX = startX;
        isDragging = true;
      });

      track.addEventListener('touchmove', function(e) {
        if (!isDragging || !e.touches || !e.touches.length) return;
        currentX = e.touches[0].clientX;
      });

      track.addEventListener('touchend', function() {
        if (!isDragging) return;
        isDragging = false;

        var diffX = currentX - startX;
        var threshold = 40; // minimum swipe distance in px
        if (Math.abs(diffX) < threshold) {
          return;
        }

        var perView = getSlidesPerView();
        var maxIndex = Math.max(0, slides.length - perView);

        // swipe left -> next, swipe right -> prev
        if (diffX < 0 && currentIndex < maxIndex) {
          currentIndex += 1;
          updateSlider();
        } else if (diffX > 0 && currentIndex > 0) {
          currentIndex -= 1;
          updateSlider();
        }
      });

      window.addEventListener('resize', function() {
        updateSlider();
      });

      updateSlider();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
